export enum MetrikaGoal {
    ClickoutChat = 'clickout_chat',
    ClickTelegram = 'clickout_telegram',
    ClickShareAchievement = 'clickout_share_achievement',
    ClickSharePrompt = 'clickout_share_prompt',
    ClickViewPrompt = 'clickout_view_prompt',
    ClickCopyPrompt = 'clickout_copy_prompt',
}

export function useMetrika() {
    // @ts-expect-error ts не знает по ym у window
    const ym = typeof window === 'undefined' ? () => {} : window.ym;

    return {
        reachGoal(goalId: MetrikaGoal) {
            ym(46120659, 'reachGoal', goalId);
            ym(105295166, 'reachGoal', goalId);
        },
    };
}
